import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules'; 
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { Button, Form, Input, Row, Icon, message, Layout, Modal } from 'antd';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect, MyStore } from 'kts-platform-frame/redux';  
const logoImg = require('./img/LOGO.png');
const { Content } = Layout;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UserJoinCompany extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            companyName:'',
            gUserId:'',
            inviteName:'',
            // ticket: this.props.location.query.ticket,
            forgetPsdModalVisible: false,
            sendSuccessMaile: '',
        };
    }  
    
    componentWillMount() {
        // const params = JSString.queryStringParse(this.props.location.search);
        // let ticket = params.ticket;
        
        // const url = `${URIS["checkActiveBindTicket"]}`;
        // const param = {
        //     ticket: ticket
        // }
        
        // const fnCallback = (err, res) => {
        //     if (err) {
        //         message.error('该链接已失效,即将跳转到登录页面');
        //         browserHistory.push(`/`)
        //         return
        //     }
        //     const data = res ? res.body : 0;
        //     if (data) {
        //         this.setState({
        //             email: data.email,
        //             gUserId: data.gUserId,
        //             inviteName: data.inviteName,
        //             companyName: data.companyName
        //         })
        //         sessionStorage.setItem("userId", data.gUserId);
        //         sessionStorage.setItem("companyId", data.companyId);
        //     }
        // };
        // Lib.Util.Super.get(url, fnCallback, param);
    }

    handleSubmit = e => {
        e.preventDefault();
        const param = {
            ticket: this.modulesState.ticket
        };
        ModulesAction.joinconpany(param);
    }
    showForgetPsdModal = () => {
        this.setState(
            {
                sendSuccessMaile: '',
                forgetPsdModalVisible: true
            }
        );
    }
    handleSubmitFpsd = e => {
        e.preventDefault();
        this.props.form.validateFields(['email'], (err, values) => { 
            if (err) { return false; }
            const domain = 'http://' + location.host;
            let send = ModulesAction.forgetSend(values.email, domain); 
            send.then((res)=>{ 
                if (res) {
                    this.setState({ sendSuccessMaile: values.email }); 
                    message.success('发送成功!');
                } 
            });
        });
    }
    sendMailAgain = () => {
        let values = {
            email: this.state.sendSuccessMaile
        };
        const domain = 'http://' + location.host;
        let send = ModulesAction.forgetSend(values.email,domain); 
        send.then((res)=>{ 
            if (res) {
                this.setState({ sendSuccessMaile: values.email }); 
                message.success('发送成功!');
            } 
        });  
    }

    render() {
        const { getFieldDecorator } = this.props.form; 
        const { config } = MyStore.instance.getState();
        const _config = JSON.parse(JSON.stringify(config)); 
        const ticketinfo = this.modulesState.ticketinfo ;
        return (
            <Layout className="invit-login"> 
               {/* <Header className="top header"> 
                    <div className="logo">
                        <div className="left"><img alt={'logo'} src={ _config.rootConfig.SiteLogo} /></div>
                        <div className="left site-name">{ _config.rootConfig.SiteName}</div>
                    </div>
                </Header> */}
                <Content style={{width: 900}} className={"invit-login-content"}>
                    <div className="yllogo">
                        <div className="yllogoimg">
                            <img alt={'logo'} src={logoImg} />
                            <span className="yllogotitle"> | 加入公司</span>
                        </div> 
                    </div> 
                    <div className="ant-card ant-card-bordered">
                        <div className="content-info">  
                            <p className='invit-info'>登录并接受  {ticketinfo && ticketinfo.inviteName}  的邀请,加入 {ticketinfo && ticketinfo.companyName} </p>
                            <div className='invit-email'>{ticketinfo && ticketinfo.email}</div>
                            <Form onSubmit={this.handleSubmit} >
                                <Row>
                                    <Button
                                        type="primary"
                                        size="large"
                                        className='submit-bt'
                                        htmlType="submit"
                                    >
                                        加入公司
                                    </Button>
                                </Row>
                            </Form>
                        </div>
                    </div>
                    <Modal
                        title="忘记密码"
                        visible={this.state.forgetPsdModalVisible}
                        footer={null}
                        width={505}
                        onCancel={() => { this.setState({ forgetPsdModalVisible: false }); }}
                    >
                        <div style={{ padding: '15px 80px' }}>
                            <Row style={{ textAlign: 'center' }}> 
                                {/* <div style={{ fontWeight: '600', textAlign: 'center', color: '#333333', fontSize: '18px', margin: '20px 0' }}> 
                                    {
                                        this.state.sendSuccessMaile
                                        &&
                                        <p>
                                            重置密码的邮件已经发送至<br />
                                            {this.state.sendSuccessMaile}
                                        </p>
                                    }
                                </div> */}
                            </Row>
                            <Form onSubmit={this.handleSubmitFpsd}>
                                {
                                    !this.state.sendSuccessMaile
                                    &&
                                    <Row>
                                        <FormItem hasFeedback={true}>
                                            {getFieldDecorator("email", {
                                                rules: [{ type: 'email', required: true, message: '请输入正确的邮箱', whitespace: true }]
                                            })(<Input size="large" placeholder='请输入您的邮箱地址' />)}
                                        </FormItem>
                                        <Row>
                                            <Button
                                                type="primary"
                                                size="large"
                                                style={{ width: '100%', margin: '5px 0' }}
                                                htmlType="submit"
                                            >
                                                重置密码
                                            </Button>
                                        </Row>
                                    </Row>
                                }{
                                    this.state.sendSuccessMaile
                                    &&
                                    <Row>
                                        <Button
                                            type="primary"
                                            size="large"
                                            style={{ width: '100%', margin: '5px 0' }}
                                            onClick={() => this.sendMailAgain()}
                                        >
                                            重新发送
                                        </Button>
                                    </Row>
                                }
                                <Row>
                                    <p style={{fontFamily: 'PingFangSC-Regular', color: '#999999', fontSize: '14px', margin: ' 25px 0'}}>
                                        如需帮助,请联系"<a href="mailto: support@kingxunlian.com">support@kingxunlian.com</a>"
                                    </p>
                                </Row>
                            </Form>
                        </div>
                    </Modal> 
                    <div className="restfooter">
                        <p><Icon type="phone" /> 服务热线 ：400-836-3566&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<Icon type="mail" /> <a href="mailto: support@kingxunlian.com">support@kingxunlian.com</a></p>
                        <p className="xunlianjt">迅联集团 2018 粤ICP备17007740号-1</p>
                    </div>
                </Content>
            </Layout>
        );
    }
}




// WEBPACK FOOTER //
// ./src/display/modules/Home/Login/UI.User.JoinCompany.tsx